import {Component, OnInit} from '@angular/core';
import {ChartType, IntervalName, ReportService} from './report.service';

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

    anxietyData: any = null;
    performanceData: any = null;
    depressionData: any = null;

    dataInterval: IntervalName = IntervalName.month;
    report: any = null;
    IntervalName = IntervalName;

    barValues: any[] = [];
    burnoutData: any = null;
    recommendations: any = null;

    tableData = [
        {
            value: 4,
            text: 'I have suicidal thoughts',
            isExclaim: true,
            color: '#FF5757'
        },
        {
            value: 1,
            text: 'I have suicidal thoughts',
            isExclaim: false,
            color: '#10082F'
        },
        {
            value: 2,
            text: 'I hate myself',
            isExclaim: false,
            color: '#10082F'
        },
        {
            value: 5,
            text: 'I have sleeping troubles',
            isExclaim: false,
            color: '#10082F'
        },
        {
            value: 1,
            text: 'I have suicidal thoughts',
            isExclaim: false,
            color: '#10082F'
        }
    ];
    cols = [
        'value',
        'text',
    ];

    importantParameters: any[] = [];

    loading = false;

    tabsData = {
        month: {},
        quartal: {},
        year: {}
    };

    activeTab: any = {};
    constructor(
        private service: ReportService
    ) {
    }

    ngOnInit(): void {
        this.loading = true;
        this.service.fetchData()
            .subscribe((res: any) => {
                this.tabsData = res;
                this.loading = false;
                this.report = this.service.report;
                this.drawData(this.dataInterval);
            }, () => {
                this.loading = false;
            });
    }

    drawData(interval: IntervalName) {
        this.activeTab = this.report[interval];
        this.dataInterval = interval;
        this.anxietyData = this.service.dashboardData(this.report, ChartType.anxiety, interval);
        this.depressionData = this.service.dashboardData(this.report, ChartType.depression, interval);
        this.performanceData = this.service.mapPerformanceData(this.report, ChartType.performance, interval);
        this.importantParameters = this.service.dataByInterval(this.report, 'important_parameters', interval);
        this.barValues = this.service.getBarValues(this.report, interval);
        this.burnoutData = this.service.dataByInterval(this.report, 'burnout', interval);
        this.recommendations = this.service.getDataByInterval(this.report, interval);
    }

    isActive(interval) {
        return interval === this.dataInterval;
    }

}
